module.exports = __webpack_public_path__ + "static/media/eve-cake.d0ea3a11.svg";